<template>
  <div class="contact-bd" id="message">
    <Toast ref="ToastRef" :message="message"></Toast>
    <div class="row">
      <div class="col-lg-6 col-12" style="box-sizing: border-box">
        <form action="" id="formData1" class="message">
          <div class="tips" style="font-size: 14px">
            <span style="font-size: 40px; color: #6f6f6f">Message</span
            ><br />注：<span>*</span>为必填项
          </div>
          <ul class="hd">
            <li>
              <span>*</span
              ><input
                type="text"
                v-model="form.username"
                autocomplete="off"
                name="name"
                placeholder="您的姓名"
              />
            </li>
            <li>
              <span>*</span
              ><input
                autocomplete="off"
                type="text"
                name="tel"
                v-model="form.phone"
                placeholder="您的电话"
              />
            </li>
          </ul>
          <ul class="md">
            <li>
              <span>*</span
              ><input
                type="text"
                name="email"
                autocomplete="off"
                v-model="form.email"
                placeholder="您的邮箱"
                class="email"
              />
            </li>
            <li style="position: relative">
              <span>*</span
              ><input
                name="captcha"
                type="text"
                placeholder="验证码"
                autocomplete="off"
                v-model="form.code"
                style="width: calc(100% - 152px); box-sizing: border-box"
              />
              <!-- <img
                id="verifyImg"
                src="/index/message/verify.html"
                onclick="refreshVerify('/index/message/verify.html?t=')"
                style="position: absolute; right: 0; width: 40%"
              /> -->
              <span
                @click="createCode"
                id="spancode"
                style="position: absolute; right: 0; width: 132px"
              >
                <Sldentify :identifyCode="code"></Sldentify>
              </span>
            </li>
          </ul>
          <ul class="bd">
            <span>*</span
            ><textarea
              name="content"
              id=""
              cols="30"
              rows="3"
              v-model="form.desc"
              placeholder="内容"
            ></textarea>
          </ul>
          <ul class="sub">
            <a class="submit" href="javascript:;" @click="submitForm">提交</a>
          </ul>
        </form>
      </div>

      <div class="col-lg-6 col-12" style="box-sizing: border-box">
        <div class="txt">
          <p class="t2">温馨提醒：</p>
          <p class="t3">
            为了能及时和您取得联系，请您务必填写您的联系方式和需求信息，您可以输入您的需求,您也可以通过商务联系我们的24小时在线客服，河南一六八线缆有限公司-致力成为您满意的合作伙伴！
          </p>
          <p class="t2">联系我们</p>
          <p class="t3">
            联系人：王建宁<br />
            电　话：0371-65555168<br />
            电　话：0371-68886168<br />
            手　机：19937116888<br />
            手　机：15837161168<br />

            邮　箱：861333640@qq.com<br />
            地　址：武陟县詹店新区昌平路3号<br />
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sldentify from "./../components/code.vue";
import { postRequest } from "@/api/axios";
import { isEmail, isMobile, isPhone } from "@/utils/validate";
import Toast from "./Toast.vue";
export default {
  components: {
    Toast,
    Sldentify,
  },
  data() {
    return {
      showMessgae: false,
      message: "",
      code: "",
      form: {
        username: "",
        phone: "",
        desc: "",
        email: "",
        code: "",
      },
    };
  },
  mounted() {
    this.createCode();
  },
  methods: {
    createCode() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      // 设置验证码长度，
      for (let i = 0; i < 4; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      this.code = text;
    },
    submitForm() {
      console.log(this.form);
      if (this.form.code === "") {
        this.message = "请输入验证码！";
        this.$refs.ToastRef.showToast(true);
        return;
      }
      if (this.form.code.toLowerCase() != this.code.toLowerCase()) {
        this.message = "验证码错误！";
        this.$refs.ToastRef.showToast(true);
        this.inputCode = "";
        this.createCode();
        return;
      }
      // i. 判空处理
      if (
        this.form.code &&
        this.form.desc &&
        this.form.email &&
        this.form.username &&
        this.form.phone
      ) {
        if (!isEmail(this.form.email)) {
          this.message = "邮箱格式错误！";
          this.$refs.ToastRef.showToast(true);
          return;
        }
        if (!isMobile(this.form.phone) && !isPhone(this.form.phone)) {
          this.message = "电话格式错误！";
          this.$refs.ToastRef.showToast(true);
          return;
        }

        postRequest("/submitForm", {
          username: this.form.username,
          user_name: this.form.username,
          password: this.form.phone,
          desc: this.form.desc,
          email: this.form.email,
          code: this.form.code,
        })
          .then((res) => {
            let data = res.data;
            if (data.code == 200) {
              this.message = data.message;
              this.$refs.ToastRef.showToast(true);
            } else if (data.code == 500) {
              this.message = "提交失败！请稍后重试！";
              this.$refs.ToastRef.showToast(true);
            }
          })
          .catch((error) => {
            console.error("Login failed:", error.message);
            this.message = "提交失败！请稍后重试！";
            this.$refs.ToastRef.showToast(true);
          })
          .finally(() => {
            this.inputCode = "";
            this.createCode();
          });
      } else {
        this.message = "请填写完整之后再进行提交！";
        this.$refs.ToastRef.showToast(true);
      }
    },
  },
};
</script>

<style>
.contact-bd {
  background: url(../assets/images/message-bg.webp) no-repeat top center;
  background-size: cover;
}
</style>
